/**
 * Notification API — CRUD operations for the notification system.
 */
import { apiClient, buildUrl } from './apiClient';
import type { NotificationListResponse } from './types';

export const getNotifications = async (
  projectId?: string | null,
  unreadOnly = false,
  limit = 50
): Promise<NotificationListResponse> => {
  const params = new URLSearchParams();
  if (projectId) params.set('project_id', projectId);
  if (unreadOnly) params.set('unread_only', 'true');
  params.set('limit', String(limit));

  const { data } = await apiClient.get(
    buildUrl(`/api/v1/notifications?${params.toString()}`)
  );
  return data;
};

export const markNotificationRead = async (
  notificationId: string
): Promise<void> => {
  await apiClient.patch(
    buildUrl(`/api/v1/notifications/${notificationId}/read`)
  );
};

export const markAllNotificationsRead = async (): Promise<{ marked: number }> => {
  const { data } = await apiClient.post(
    buildUrl('/api/v1/notifications/mark-all-read')
  );
  return data;
};
